import { supabase } from '../lib/supabase'

export async function splitConversationAtMessage(
  conversationId: string,
  messageId: string
): Promise<string> {
  const { data, error } = await supabase.rpc('split_conversation_at_message', {
    p_conversation_id: conversationId,
    p_message_id: messageId,
  })
  if (error) throw error
  return data as string
}

export async function moveMessageToConversation(
  messageId: string,
  targetConversationId: string
): Promise<void> {
  const { error } = await supabase.rpc('move_message_to_conversation', {
    p_message_id: messageId,
    p_target_conversation_id: targetConversationId,
  })
  if (error) throw error
}
